(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ExampleEditor", [], factory);
	else if(typeof exports === 'object')
		exports["ExampleEditor"] = factory();
	else
		root["ExampleEditor"] = factory();
})(this, function() {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/